import {
  CloudArrowUpIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";
import MileleHealthPlan from "./MileleHealthPlan";

export default function HealthBody() {
  return (
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
      <div className="mx-auto grid max-w-2xl  gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:items-start lg:gap-y-10">
        <div className=" lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">
                Health Insurance
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Kinga Ya Mkulima
              </h1>
            </div>
          </div>
        </div>

        <div className=" lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className=" text-base leading-7 text-gray-700 ">
              <p>
                Kinga Ya Mkulima is specially designed for small scale tea
                farmers that are registered with the Kenya Tea Development
                Agency. This is a unique medical covered that was engineered
                with one purpose in mind, to protect the well-being of the
                entire family at the most affordable cost and highest care
                possible. This is a medical cover that is tailored for the
                masses, and whose scope advances some very progressive aspects
                in medical insurance in Kenya.
              </p>
              <p>
                Kinga Ya Mkulima is a wholesome family medical and life cover.
                The product caters for Inpatient, Outpatient and Last expense
                benefit.
              </p>
              <h5 className="pt-8">
                <strong>
                  Why you will fall in love with Kinga ya Mkulima:
                </strong>
              </h5>
              <ul className="list-disc list-inside">
                <li>
                  Eligibility for insured and spouse at entry, minimum age is
                  18yrs, maximum age 75yrs.
                </li>
                <li>
                  Children are only eligible if they are 18 years and below but
                  cover will continue until age 23, if one is a student.
                </li>
                <li>
                  New born child shall automatically be admissible on birth at
                  an extra cost but the company should be notified of the new
                  member and a premium paid before cover commences. Each member
                  is covered for the same daily benefit.
                </li>
                <li>
                  The policy pays the daily rate per day for the number of days
                  admitted OR the entire bill whichever is lower. In addition
                  the policy covers a maximum of 10 times of the daily hospital
                  benefit to cover cost associated with surgery, including
                  anesthetic fee.
                </li>
              </ul>

              <h5 className="pt-8">
                <strong>
                What is not covered under Kinga ya Mkulima?                </strong>
              </h5>
              <ul className="list-disc list-inside">
                <li>
               Misrepresentation of information given on the application form

                </li>
                <li>
               Hospitalization or death within the 3 months waiting period, except for accidental cases

                </li>
                <li>
                  Maternity related hospitalization within the 10 months waiting period (no maternity cover for children)

                </li>
                <li>
               Drug abuse and alcoholism related treatments

                  
                </li>
                <li>
                Hospitalization or death resulting from injuries sustained from an illegal act

                </li>
                <li>
                Outpatient services
                </li>
              </ul>
              
            </div>
          </div>
        </div>
      </div>
      <div>
        
      </div>
      <MileleHealthPlan/>

     

     
     
      
    </div>
  );
}
